import { render, staticRenderFns } from "./AddProviderBasicInfo.vue?vue&type=template&id=faf65ca8"
import script from "./AddProviderBasicInfo.vue?vue&type=script&lang=js"
export * from "./AddProviderBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports